import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { SpinnerVisibilityService } from 'ng-http-loader';
import Swal from 'sweetalert2'
import { BMApiService } from '../../../services/bm.service';
import { Router } from '@angular/router';
import { UserService } from '../../../services/user.service';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  GridStateChange,
  MenuCallbackArgs
} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { UtilityService } from '../../../services/utility.service';
import { AdminApiService } from '../../../services/admin.service';
import { tranbenchmarkkpi, tranbenchmarkkpihistory, benchmarkkpirelease, annualPerformanceBM, annualStatusHistroy, annualNomination } from '../../../models/slakpi';
import { division, department } from '../../../models/admin';
import { ToasterService } from '../../../toaster.service';
import { uniqBy } from 'lodash';
@Component({
  selector: 'awareness-session',
  templateUrl: './awareness-session.component.html',
  styleUrls: ['./awareness-session.component.css']
})
export class AwarenessSessionComponent implements OnInit {
  
  
  public gridApi: any;
  public gridColumnApi: any;
  public columnDefs: any;
  public defaultColDef: any;
  public rowData: any;
  public PopoverModule;
  modalRef: BsModalRef;
  submitted: boolean = false;
  @ViewChild('addtemplate', { static: false }) addtemplate: TemplateRef<any>;
  @ViewChild('addNominationTemplate', { static: false }) addNominationTemplate: TemplateRef<any>; 
  @ViewChild('statusUpdateTemplate', { static: false })statusUpdateTemplate: TemplateRef<any>;
  @ViewChild('statusUpdateHistroyTemplate', { static: false }) statusUpdateHistroyTemplate: TemplateRef<any>;
  columnDefinitions: Column[];
  columnAtdDefinitions: Column[];
  atdGrid: AngularGridInstance;
  gridOptions: GridOption;
  dataset: any;
  angularGrid: AngularGridInstance;
  public PerformanceBM_data: any;
  public loading: boolean = true;
  public pageAction: string = 'add';
  btnText: string = 'Add';
  public isStart:boolean=true;
  public selectedRows: any = [];
  public division_data: any;
  public department_data: any;
  public KPIMeasure_data: any;
  public Level_data: any;
  public Type_data: any;
  public bm_data: any;
  public datasetNomination: any = [];
  public annualTitleList: any = [];
  data: any;
  objNomination: any = new annualNomination();
  objAnnualPerformance: any = new annualPerformanceBM();
  objStatusHistroy: any = new annualStatusHistroy();
    searchText: string;
    performanceStatusHistroyDataSet: any[];
    dataHistroy: any;
    histroyColumnDefinitions: any;
    editID: any;
    userList: any;
  login_UserID: any;
  statusDDList = [{ value: 0, text: 'Draft' },{ value: 1, text: 'Approved' }, { value: 2, text: 'Rejected' }]
  user: any = {};
  isAdmin: boolean;
  public isBMChampion: boolean = false;
  public isBMTeam: boolean = false;
  public isBMVisitor: boolean = false;
  public isBMAdmin: boolean = false;
  noDataImg: any;
  tenantUno: any;
  constructor(public restApi: BMApiService, public restAdminApi: AdminApiService, private toaster: ToasterService, public utilityService: UtilityService, private router: Router, private spinner: SpinnerVisibilityService, private userService: UserService, private modalService: BsModalService) {

    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.noDataImg = this.utilityService.getnodataImage();
    this.tenantUno = this.user.tenantUno;
    this.ValidateUserAccess();
  }
  //Method used To Validate User Permission

  ValidateUserAccess() {
    
    this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'BM Administrator') ? true : false;

    if (this.user.role == 'BM Champions')
      this.isBMChampion = true;
    if (this.user.role == 'BM Team')
      this.isBMTeam = true;
    if (this.user.role == 'BM Visitor')
      this.isBMVisitor = true;
    if (this.user.role == 'BM Administrator') { this.isBMAdmin = true; }

    if (!this.isAdmin) {
      let userPermissionData = this.userService.getUserRights("Awarness Session");
      if (userPermissionData != null && userPermissionData != undefined && userPermissionData.length > 0) {
        if (userPermissionData[0].showPage == 1) {

        }
        else {
          this.router.navigateByUrl('/access-denied');
        }
      }
    }

  }

  ngOnInit() {
    this.userService.CheckLogin();
    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,
     
      multiSelect: false,
      rowSelectionOptions: {
        // True (Single Selection), False (Multiple Selections)
        selectActiveRow: true,
      },



    };
    this.userList = this.userService.getUserInfo();
    this.login_UserID = this.userList.id;
    
    this.getAnnualNomination();
    this.getAwarnessTitle();
  }

  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }
  handleSelectedRowsChanged1(e, args) {
    
    if (Array.isArray(args.rows) && this.angularGrid) {
      this.selectedRows = this.angularGrid.gridService.getSelectedRowsDataItem();
    }
  }
  
  angularAtdGridReady(angularGrid: AngularGridInstance) {
    this.atdGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }
  
  
 

  
  openModalWithClass() {
    this.pageAction = "add";
    this.objNomination = new annualNomination();
    this.modalRef = this.modalService.show(
      this.addNominationTemplate,
      Object.assign({}, {
        class: 'gray modal-lg',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
  }

  

  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
  };
  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val;
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' '

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val.trim()
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' '

  }


  searchGrid() {
    if (this.searchText != "") {
      this.datasetNomination = this.data.filter(a =>
        a.employeeName && a.employeeName.toLowerCase().includes(this.searchText.toLowerCase())
        || (a.prNumber && a.prNumber.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.designation && a.designation.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.email && a.email.toLowerCase().includes(this.searchText.toLowerCase()))
        );
    }
    else
      this.datasetNomination = this.data;
  }
 




  

  getAnnualNomination() {
    
    let inpValue = new annualNomination();
    inpValue.annualPerformanceBMUno = 0;
    inpValue.condition = 0;
    inpValue.userUno = this.login_UserID;
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getAnnualNomination(inpValue)
      .subscribe(data => {
        
        let filterDataSet = uniqBy(data, 'id');
        const mockDataset = [];

        if (filterDataSet.length > 0) {
        for (let i = 0; i < filterDataSet.length; i++) {

          mockDataset[i] = {
            id: filterDataSet[i].id,
            employeeName: filterDataSet[i].employeeName,
            prNumber: filterDataSet[i].prNumber,
            designation: filterDataSet[i].designation,
            email: filterDataSet[i].email,
            awarenessTitle: filterDataSet[i].awarenessTitle,
            status: (filterDataSet[i].status == '') ? 'Draft' : filterDataSet[i].status
          };
        }
          this.datasetNomination = mockDataset;
          this.data = mockDataset;
        if (mockDataset.length > 0) {
          this.setAtdDefn();
        }
        else {

          this.setAtdDefn();
          }
          this.loading = false;
          this.spinner.hide()
      }
        else {
          this.datasetNomination = [];
         
          this.loading = false;
          this.spinner.hide()
        }
      
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }


  getAwarnessTitle() {
    
    let inpValue = new annualNomination();
    inpValue.annualPerformanceBMUno = 0;
    inpValue.condition = 1;
    this.restApi.getAnnualNomination(inpValue)
      .subscribe(data => {
        
        this.annualTitleList = data;
          this.loading = false;
          this.spinner.hide()
        

      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }
  setAtdDefn() {
    this.columnAtdDefinitions = [
      {
        id: 'employeeName', name: 'Name', field: 'employeeName', sortable: true, type: FieldType.string, filterable: false, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'employeeName', 'employeeName'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'prNumber', name: 'PR Number', field: 'prNumber', sortable: true, type: FieldType.string, filterable: false, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'prNumber', 'prNumber'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'designation', name: 'Designation', field: 'designation', sortable: true, type: FieldType.string, filterable: false, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'designation', 'designation'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'email', name: 'Email', field: 'email', sortable: true, type: FieldType.string, filterable: false, width: 100,
        filter: {
          collection: this.uniqueArray(this.dataset, 'email', 'email'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'status', name: 'Status', field: 'status', sortable: true, type: FieldType.string, filterable: false, width: 50,
        formatter: (row, cell, val, columnDef, data) => {
          if(data.status == 'Draft')
            return '<span  class="status-area status-yellow">Draft</span>';
          else if (data.status == 'Approved')
            return '<span  class="status-area status-green">Approved</span>';         
          else if (data.status == 'Rejected')
            return '<span  class="status-area status-red">Rejected</span>';

        },
        filter: {
          collection: this.uniqueArray(this.dataset, 'status', 'status'),
          model: Filters.multipleSelect,

        }
      },
    
      
      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 25,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          commandItems: [

            {
              command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'Edit',

              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if (this.isBMVisitor)
                  return false;
                else return true;
              },
              iconCssClass: 'fa fa-lg fa-edit', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'edit';
                let rdata: any = args.dataContext;
                this.objNomination = new annualNomination();
                this.objNomination = rdata;
                
                this.modalRef = this.modalService.show(
                  this.addNominationTemplate,
                  Object.assign({}, {
                    class: 'gray modal-lg',
                    backdrop: true,
                    keyboard: true,
                    focus: true,
                    show: false,
                    ignoreBackdropClick: true,
                    animated: true
                  })
                );
                this.btnText = 'Update';
              },
              //  // only show command to 'Delete Row' when the task is not completed

            },
            { divider: true, command: '', positionOrder: 63 },
            {
              command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'Approve/Reject',

              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if (this.isBMTeam || this.isBMVisitor)
                  return false;
                else return true;
              },
              iconCssClass: 'fa fa-lg fa-file', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'edit';
                let rdata: any = args.dataContext;
                this.objNomination = new annualNomination();
                this.objNomination = rdata;

                this.editID = this.objNomination.id;
                
                this.modalRef = this.modalService.show(
                  this.statusUpdateTemplate,
                  Object.assign({}, {
                    class: 'gray modal-lg modal-medium',
                    backdrop: true,
                    keyboard: true,
                    focus: true,
                    show: false,
                    ignoreBackdropClick: true,
                    animated: true
                  })
                );
                this.btnText = 'Update';
              },
              //  // only show command to 'Delete Row' when the task is not completed

            },
            {
              command: 'atd-row', titleKey: 'atd_ROW', positionOrder: 64, title: 'Delete',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if ( this.isBMVisitor)
                  return false;
                else return true;
              },
              iconCssClass: 'fa fa-lg fa-trash', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'view';
                let rdata: any = args.dataContext;
                this.objNomination = new annualNomination();
                this.objNomination = rdata;

                Swal.fire({
                  text: 'Please confirm to delete',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ok',
                  cancelButtonText: 'Cancel'
                }).then((result) => {
                  if (result.value) {
                    //this.pageAction = 'delete';
                    //this.objNomination.isActive = 0;
                    this.delNomination();
                  } else if (result.dismiss === Swal.DismissReason.cancel) {
                  }
                })

              },
              //  // only show command to 'Delete Row' when the task is not completed

            },


          ],
        }
      }
    ];
  }
  addNomination(val) {
    

    if (!val.form.valid) {
      //Swal.fire('Error', 'Please enter required field.', 'error');
      this.toaster.show('warning', 'Warning', 'Please enter required field.');
      return;
    }

    if (this.objNomination.email != '') {
      if (!this.validateEmail(this.objNomination.email)) {
       
        this.toaster.show('warning', 'Warning', 'Enter valid email.');
        return false;
      }
    }

    this.objNomination.nominationUno = (this.btnText == 'Add') ? 0 : this.objNomination.id;
    this.objNomination.annualPerformanceBMUno = 0;
    this.objNomination.condition = (this.btnText == 'Add')?0:1;
    this.objNomination.userUno = this.login_UserID;
    this.objNomination.tenantUno = this.tenantUno;
    this.restApi.addEditAnnualNomination(this.objNomination)
      .subscribe(data => {
       
        
        
        val.submitted = false;
        this.modalRef.hide();

        this.toaster.show('success', 'Success', (this.btnText == "Add") ? 'Nomination is saved.' : 'Nomination is updated.');
        this.getAnnualNomination();
        this.objNomination = new annualNomination();
        val.submitted = false;
        this.btnText = 'Add';

      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });

  }

  cancelNomination(val) {
    this.objNomination = new annualNomination();
    //this.btnText = 'Add';
    val.submitted = false;
    this.modalRef.hide();
  }

  delNomination() {
    
    this.objNomination.condition = 2;
    this.objNomination.nominationUno = this.objNomination.id;
    this.objNomination.userUno = this.login_UserID;
    this.objNomination.tenantUno = this.tenantUno;
    this.restApi.addEditAnnualNomination(this.objNomination)
      .subscribe(data => {
        //Swal.fire({
        //  type: 'success',
        //  title: 'Attendee is deleted.',
        //  showConfirmButton: false,
        //  timer: 1500
        //})
        this.toaster.show('success', 'Success', 'Nomination is deleted.');
        this.getAnnualNomination();
        this.objNomination = new annualNomination();
        this.modalRef.hide();

      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });

  }

  onStatusSubmit(val1) {
    
    if (!val1) {
      this.toaster.show('error', 'Error', 'Please enter the required information');
      return
    }

    else {
      this.updateAnnualPerformanceStatus(this.objStatusHistroy);
    }
  }
  updateAnnualPerformanceStatus(data1: any) {
    



    let obj = new annualStatusHistroy();
    obj = data1;
    obj.id = (this.editID) ? this.editID : 0;
    obj.comments = (this.objStatusHistroy.comments) ? this.objStatusHistroy.comments : '';
    obj.status = this.objStatusHistroy.status;
    obj.userUno = this.login_UserID;
    obj.flag = 'AwarenessSession';
    this.restApi.updateAnnualStatus(obj)
      .subscribe(data => {

        if (data != null && data != undefined && data != '' && data != 'failure') {
          this.toaster.show('error', 'Error', 'Something went wrong');
          this.spinner.hide();
        }
        else {
          this.toaster.show('success', 'Success', 'Status Updated.');
          setTimeout(() => {
            this.objStatusHistroy = new annualStatusHistroy();
            this.spinner.hide();
            this.getAnnualNomination();
            this.modalRef.hide();
          }, 500);

          

        }



      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });
    return true;

  }

  validateEmail(email) {
    const regularExpression = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regularExpression.test(String(email).toLowerCase());
  }
}


